module.exports = __webpack_public_path__ + "static/media/dot.5d2da7bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dot.svg
// module id = 210
// module chunks = 1